<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {network, parameter} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import {decode, encode} from "../../../helpers";


    export const transliterate = (str) => {
        const map = {
            'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo', 'ж': 'zh',
            'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
            'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'kh', 'ц': 'ts',
            'ч': 'ch', 'ш': 'sh', 'щ': 'shch', 'ъ': '', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu',
            'я': 'ya', ' ': '_', '-': '-', '.': '.', ',': '', '(': '_', ')': '_'
        };

        let result = '';
        for (let i = 0; i < str.length; i++) {
            const char = str[i].toLowerCase();
            if (map[char] !== undefined) {
                result += map[char];
            } else {
                result += char; // если символ не найден — оставляем как есть
            }
        }

        return result
            .replace(/[^a-z0-9._-]/g, '') // убираем всё, кроме латиницы, цифр, точек, тире, подчёркивания
            .replace(/_{2,}/g, '_')        // заменяем множественные подчёркивания на одно
            .replace(/^-+|-+$/g, '');      // убираем тире в начале и конце
    };

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    const motori = options.motor || {
        'Novo N21 220В': 'Novo N21 220В',
        'Novo N21 220В Wi-fi': 'Novo N21 220В Wi-fi',
        'Novo N21 АКБ USB -type C': 'Novo N21 АКБ USB -type C',
        'N99 220В Wi-Fi': 'N99 220В Wi-Fi',
        'N99 АКБ USB-type C': 'N99 АКБ USB-type C',
        'Без мотора': 'Без мотора',

    }
    const upr = options.upr || {
        'Пульт Novo А13 (6 каналов)': 'Пульт Novo А13 (6 каналов)',
        'Пульт Novo А6 (9 каналов)': 'Пульт Novo А6 (9 каналов)',
        'Пульт Novo А6 (99 каналов)': 'Пульт Novo А6 (99 каналов)',
        'Нет': 'Нет'

    }

    const dop_upr = options.dop_upr || {

        'Кнопка Novo А9 (1 канал белая)': 'Кнопка Novo А9 (1 канал белая)',
        'Кнопка Novo А9 (2 канала белая)': 'Кнопка Novo А9 (2 канала белая)',
        'Кнопка Novo А9 (1 канал черная)': 'Кнопка Novo А9 (1 канал черная)',
        'Кнопка Novo А9 2 (канал черная)': 'Кнопка Novo А9 2 (канал черная)',
        'Нет': 'Нет'
    }


    const translitMotori = Object.fromEntries(
        Object.entries(motori).map(([k, v]) => [transliterate(k), v])
    );

    const translitUpr = Object.fromEntries(
        Object.entries(upr).map(([k, v]) => [transliterate(k), v])
    );

    const translitDopUpr = Object.fromEntries(
        Object.entries(dop_upr).map(([k, v]) => [transliterate(k), v])
    );

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar);
            let json = JSON.parse(decode(fetched.ind3));

            fetchData = await fetch();
            width.set(json.width);
            height.set(json.height);
            type = json.type;
            motor = json.motor;
            razdvizka = json.razdvizka;
            begun = json.begun;
            uprav = json.uprav;
            dop_uprav = json.dop_uprav;
            podves = json.podves

            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };


    const fetch = async () => {
        let result = await network.fetch_data('Лифт система', 'Лифт система', '');


        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '2500'),
        motor = Object.values(motori).shift(),
        type = 'Лифт система',
        razdvizka = 'К центру',
        begun = "8",
        uprav = Object.values(upr).shift(),
        dop_uprav = 'Нет',
        solnbat = 'Нет',

        //лифт системы
        height = parameter('height', '4000'),
        podves = 'Для 1 карниза',


        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1),

        motorImg = "",
        motorOpis = "",
        upravImg = "",
        upravDopImg = ""
    ;

    let fetchData = fetch();
    // let
    // montage_item,
    // montage_price = 1;


    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height;

        let title = [
            type, ' ',
            (type == 'Электро карнизы' ?
                    w + ' мм' + ', ' + motor + ', Бегунки через см  ' + begun + ',  ' + razdvizka + ',  ' + uprav + ',  ' + dop_uprav
                    :
                    w + 'x' + h + ', ' + podves + ',  ' + uprav + ',  ' + dop_uprav
            )
        ].join('')

        let result = {
            type: 'Электро карнизы и Лифт система',
            name: 'Электро карнизы и Лифт система',
            subname: title.replace('Электро карнизы и Лифт система', type.capitalize()).trim(),
            title,
            params: {
                ind1: [
                    type === 'Электро карнизы' ?
                        type + ', ' + $width + ', ' + motor + ', ' + uprav + ', ' + dop_uprav
                        :
                        type + ', ' + $width + ', ' + $height + ', ' + podves + ', ' + uprav + ', ' + dop_uprav
                ].join(''),
                ind2: '', // цвет
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height, // для лифт системы
                    type,
                    motor,
                    podves,
                    razdvizka,
                    begun,
                    uprav,
                    dop_uprav,
                })),
                ind4: $width,
                ind5: begun,
            },

            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            maxDay: 0,
            materials: {},
            comment: $comment,
            vStrukture: 124, //категория в которую посчитанные изделия
        };

        upravImg = 'Нет'
        motorOpis = ''

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;


            function EvenInteger(num) {
                const roundedNum = Math.round(num); // Округляем до ближайшего целого

                if (roundedNum % 2 === 0) {
                    return roundedNum; // Если четное, возвращаем
                } else {
                    // Если нечетное, проверяем, ближе ли большая или меньшая четная цифра
                    if (Math.abs(roundedNum + 1 - num) < Math.abs(roundedNum - 1 - num)) {
                        return roundedNum + 1;
                    } else {
                        return roundedNum - 1;
                    }
                }
            }

            if (name == motor.toLowerCase() && type == 'Электро карнизы') {
                if (motor.toLowerCase() == 'без мотора') {
                    kolvo = (0).toFixed(3);
                } else {
                    kolvo = (1).toFixed(3);
                }
                motorImg = item.foto_small;
                motorOpis = item.opisanie;
            }

            if (name == 'Карниз шторный для моторизации'.toLowerCase() && type == 'Электро карнизы') {
                kolvo = (w / 1000).toFixed(3);
            }

            if (name == 'Ремень шторный'.toLowerCase() && type == 'Электро карнизы') {
                kolvo = (w * 2 / 1000).toFixed(3);
            }

            if (name == 'Бегунки шторные'.toLowerCase() && type == 'Электро карнизы') {
                kolvo = EvenInteger(w / begun / 10).toFixed(3);
            }

            if (name == 'Заглушки торцевые N18'.toLowerCase() && motor.includes('N18') && type == 'Электро карнизы') {
                kolvo = (2).toFixed(3);
            }

            if (name == 'Блок подключения мотора N99 комплект'.toLowerCase() && motor.includes('N99') && type == 'Электро карнизы') {
                kolvo = (2).toFixed(3);
            }


            if (name == 'Блок подключения мотора N21 комплект'.toLowerCase() && motor.includes('N21') && type == 'Электро карнизы') {
                kolvo = (2).toFixed(3);
            }

            if (name == 'Стопор'.toLowerCase() && type == 'Электро карнизы') {
                kolvo = (2).toFixed(3);
            }

            if (name == 'Улитка'.toLowerCase() && type == 'Электро карнизы') {
                kolvo = (EvenInteger(w / begun / 10) + 20).toFixed(3);
            }

            if (name == 'Мастер глайдер'.toLowerCase() && type == 'Электро карнизы') {
                if (razdvizka.toLowerCase() == 'к центру') {
                    kolvo = (2).toFixed(3);
                } else {
                    kolvo = (1).toFixed(3);
                }
            }

            if (name == 'Эксцентрик'.toLowerCase() && type == 'Электро карнизы') {
                kolvo = (Math.round((w / 1000 / 0.5))).toFixed(3);
            }

            if (name == uprav.toLowerCase()) {
                kolvo = (1).toFixed(3);


                upravImg = item.foto_small
            }

            if (name == dop_uprav.toLowerCase()) {
                if (dop_uprav.toLowerCase() == 'нет') {
                    kolvo = (0).toFixed(3);

                } else {
                    kolvo = (1).toFixed(3);
                }
                upravDopImg = item.foto_small
            }


            if (name == 'Сборка шторного электрокарниза'.toLowerCase() && type == 'Электро карнизы') {
                kolvo = (1).toFixed(3);
            }


            if (name == 'Сборка лифт системы'.toLowerCase() && type == 'Лифт система') {
                kolvo = (1).toFixed(3);
            }


            if (name == 'Novo К45 (лифт)'.toLowerCase() && type == 'Лифт система') {
                if (podves == 'Для 1 карниза') {
                    kolvo = (1).toFixed(3);
                } else {
                    kolvo = (1).toFixed(3);
                }
            }

            if (name == 'Адаптер трубы 55'.toLowerCase() && type == 'Лифт система') {
                if (podves == 'Для 1 карниза') {
                    kolvo = (1).toFixed(3);
                } else {
                    kolvo = (1).toFixed(3);
                }
            }

            if (name == 'Кронштейн для 55 трубы'.toLowerCase() && type == 'Лифт система') {
                if (podves == 'Для 1 карниза') {
                    kolvo = (1).toFixed(3);
                } else {
                    kolvo = (1).toFixed(3);
                }
            }

            if (name == 'Цилиндр намоточный'.toLowerCase() && type == 'Лифт система') {
                if (podves == 'Для 1 карниза') {
                    kolvo = Math.ceil(w / 1000 / 0.7).toFixed(3);
                } else {
                    kolvo = Math.ceil(w / 1000 / 0.7).toFixed(3);
                }
            }

            if (name == 'Трос'.toLowerCase() && type == 'Лифт система') {
                if (podves == 'Для 1 карниза') {
                    kolvo = ((Math.ceil(w / 1000 / 0.7)) * h / 1000).toFixed(3);
                } else {
                    kolvo = ((Math.ceil(w / 1000 / 0.7)) * h / 1000).toFixed(3);
                }
            }

            if (name == 'Держатель карниза 1-рядный'.toLowerCase() && type == 'Лифт система') {
                if (podves == 'Для 1 карниза') {
                    kolvo = (Math.ceil(w / 1000 / 0.7)).toFixed(3);
                }
            }

            if (name == 'Держатель карниза 2-рядный'.toLowerCase() && type == 'Лифт система') {
                if (podves == 'Для 2 карнизов') {
                    kolvo = (Math.ceil(w / 1000 / 0.7)).toFixed(3);
                }
            }

            if (name == 'Провод спиральный'.toLowerCase() && type == 'Лифт система') {
                if (podves == 'Для 1 карниза') {
                    kolvo = (1).toFixed(3);
                } else {
                    kolvo = (2).toFixed(3);
                }
            }

            if (name == 'Труба 55'.toLowerCase() && type == 'Лифт система') {
                if (podves == 'Для 1 карниза') {
                    kolvo = (w / 1000).toFixed(3);
                } else {
                    kolvo = (w / 1000).toFixed(3);
                }
            }

            if (name.includes('Солнечная панель'.toLowerCase()) && (solnbat=='Да')) {
                kolvo = (1).toFixed(3);
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.maxDay = Math.max((result.maxDay ?? 0), parseInt(item.ind1) || 0);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }


        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!-- <pre>{JSON.stringify(data, null, 4)}</pre>-->

    <style>
        .parentElectro {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-auto-rows: auto;
            grid-column-gap: 5px;
            grid-row-gap: 0px;
            grid-template-areas:

                    "type type"
                    "gabarit gabarit"
                    "motor motor"
                    "solnbat solnbat"
                    "razdvizka razdvizka"
                    "begun begun"
                    "upravlenie upravlenie"
                    "dopUpravlenie dopUpravlenie"
                    "comment comment"
                    "motorImg motorImg"
                    "upravImg upravImg"
                    "upravDopImg upravDopImg";
        }

        .parentLift {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-auto-rows: auto;
            grid-column-gap: 5px;
            grid-row-gap: 0px;
            grid-template-areas:
                    "type type"
                    "info info"
                    "widthLift heightLift"
                    "podves podves"
                    "upravlenie upravlenie"
                    "dopUpravlenie dopUpravlenie"
                    "comment comment"
                    "liftImg liftImg"
                    "upravImg upravImg"
                    "upravDopImg upravDopImg";
        }

        @media (min-width: 575.98px) {
            .parentElectro {
                grid-template-columns: repeat(3, 1fr);
                grid-template-areas:
                    "type type motorImg"
                    "gabarit gabarit motorImg"
                    "motor motor motorImg"
                    "solnbat solnbat motorImg"
                    "razdvizka razdvizka upravImg"
                    "begun begun upravImg "
                    "upravlenie upravlenie upravImg"
                    "dopUpravlenie dopUpravlenie upravDopImg"
                    "comment comment upravDopImg"
                     ". . upravDopImg";
            }

            .parentLift {
                grid-template-columns: repeat(3, 1fr);
                grid-template-areas:
                    "type type type"
                    "info info info"
                    "widthLift heightLift liftImg"
                    "podves podves liftImg"
                    "upravlenie upravlenie upravImg"
                    "dopUpravlenie dopUpravlenie upravImg"
                    "comment comment upravDopImg";

            }
        }


        .comment {
            grid-area: comment;
        }

        .upravDopImg {
            grid-area: upravDopImg;
        }

        .upravImg {
            grid-area: upravImg;
        }

        .motorImg {
            grid-area: motorImg;
        }

        .dopUpravlenie {
            grid-area: dopUpravlenie;
        }


        .upravlenie {
            grid-area: upravlenie;
        }

        .begun {
            grid-area: begun;
        }

        .razdvizka {
            grid-area: razdvizka;
        }

        .motor {
            grid-area: motor;
        }

        .type {
            grid-area: type;
        }

        .gabarit {
            grid-area: gabarit;
        }

        .info {
            grid-area: info;
        }

        .heightLift {
            grid-area: heightLift;
        }

        .widthLift {
            grid-area: widthLift;
        }

        .podves {
            grid-area: podves;
        }

        .liftImg {
            grid-area: liftImg;
        }

        .solnbat {
            grid-area: solnbat;
        }


    </style>
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>

        <div class={type === 'Электро карнизы'? 'parentElectro' : 'parentLift' }>
            <div class="type d-none">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Тип </label>
                        <select class="form-control form-select" bind:value={type}>
                            <option value="Электро карнизы">Электро карнизы</option>
                            <option value="Лифт система">Лифт система</option>
                        </select>
                    </div>
                </div>
            </div>

            {#if type === 'Лифт система'}
                <div class="info">
                    <div class="alert alert-outline-danger">
                        Стоимость системы без шторных карнизов
                    </div>
                </div>
            {/if}

            {#if type === 'Электро карнизы'}
                <div class="gabarit">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Карниз габарит в мм</label>
                            <!--                        <input type="number" class="form-control" step="1" min="250"-->
                            <!--                               max="{ options.max && options.max.width ? options.max.width : 1300 }" bind:value={$width}-->
                            <!--                               use:validate_int={$width}>-->
                            <input type="number" class="form-control" step="1" min="250"
                                   bind:value={$width}
                                   use:validate_int={$width}>
                        </div>
                    </div>
                </div>
            {/if}

            {#if type === 'Лифт система'}
                <div class="widthLift">
                    <div class="form-group boxed">
                        <div class="input-wrapper">

                            <!--                            <label class="form-label">300 ≥ Шир., см ≥ 2850</label>-->
                            <!--                            <input type="number"-->
                            <!--                                   class="form-control text-center { ($width > 2850 || $width < 300) ? 'text-danger' : '' }"-->
                            <!--                                   step="1"-->
                            <!--                                   min="300"-->
                            <!--                                   max="2850"-->
                            <!--                                   bind:value={$width} use:validate_int={$width}>-->
                            <label class="form-label">Ширина, мм</label>
                            <input type="number"
                                   class="form-control text-center"
                                   step="1"
                                   bind:value={$width} use:validate_int={$width}>
                        </div>
                    </div>
                </div>

                <div class="heightLift">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <!--                            <label class="form-label">300 ≥ Выс., см ≥ 3000</label>-->
                            <!--                            <input type="number"-->
                            <!--                                   class="form-control text-center { ($height > 3000 || $height < 300  ) ? 'text-danger' : '' }"-->
                            <!--                                   step="1"-->
                            <!--                                   min="300"-->
                            <!--                                   max="3000"-->
                            <!--                                   bind:value={$height} use:validate_int={$height}>-->
                            <label class="form-label">Высота, мм</label>
                            <input type="number"
                                   class="form-control text-center"
                                   step="1"
                                   bind:value={$height} use:validate_int={$height}>
                        </div>
                    </div>
                </div>
            {/if}

            {#if type === 'Электро карнизы'}
                <div class="motor">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Мотор</label>
                            <select class="form-control form-select" bind:value={motor}>
                                {#each Object.entries(motori) as [value, name]}
                                    <option value="{value}">{name}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
            {/if}
            {#if motor.includes('АКБ')}
                <div class="solnbat">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Солнечная панель</label>
                            <select class="form-control form-select" bind:value={solnbat}>
                                <option value="Да">Да</option>
                                <option value="Нет">Нет</option>
                            </select>
                        </div>
                    </div>
                </div>

            {/if}


            {#if type === 'Лифт система'}
                <div class="podves">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Подвес</label>
                            <select class="form-control form-select" bind:value={podves}>
                                <option value="Для 1 карниза">Для 1 карниза</option>
                                <option value="Для 2 карнизов">Для 2 карнизов</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}

            {#if type === 'Электро карнизы'}
                <div class="razdvizka">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Раздвижка</label>
                            <select class="form-control form-select" bind:value={razdvizka}>
                                <option value="К центру">К центру</option>
                                <option value="В одну сторону">В одну сторону</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}

            {#if type === 'Электро карнизы'}
                <div class="begun">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Бегунки через см</label>
                            <select class="form-control form-select" bind:value={begun}>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}

            <div class="upravlenie">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Управление пульт</label>
                        <select class="form-control form-select" bind:value={uprav}>
                            {#each Object.entries(upr) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="dopUpravlenie">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Дополнительное управление</label>
                        <select class="form-control form-select" bind:value={dop_uprav}>
                            {#each Object.entries(dop_upr) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="comment">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>

            {#if type === 'Электро карнизы'}
                {#if (motor !== 'Без мотора')}
                    <div class="motorImg">
                        <div class="form-group boxed">
                            <div class="container">
                                <img style="max-height: 250px" class="img-fluid"
                                     src={ 'https://225304.selcdn.ru/axisdb/'+  motorImg }/>
                                {#if (motor !== 'Без мотора')}
                                    <div class="small pb-2">
                                        {@html motorOpis.replaceAll(' / ', '<br>')}
                                    </div>
                                {/if}
                            </div>
                        </div>
                    </div>
                {/if}

                <div class="upravImg">
                    {#if (upravImg !== 'Нет')}
                        <div class="form-group boxed">
                            <div class="container text-center">
                                <img style="max-height: 250px; " class="img-fluid"
                                     src={  'https://225304.selcdn.ru/axisdb/'+ upravImg }/>
                            </div>
                        </div>
                    {/if}
                </div>

                {#if (dop_uprav !== 'Нет')}
                    <div class="upravDopImg">
                        <div class="form-group boxed">
                            <div class="container text-center">
                                <img style="max-height: 250px; " class="img-fluid"
                                     src={  'https://225304.selcdn.ru/axisdb/'+ upravDopImg }/>
                            </div>
                        </div>
                    </div>
                {/if}
            {/if}
            {#if type === 'Лифт система'}

                <div class="liftImg">
                    <div class="form-group boxed">
                        <div class="container text-center">
                            <img style="max-height: 250px; " class="img-fluid"
                                 src={ '/img/other/elktrokarniz/lift.jpg' }/>
                        </div>
                    </div>
                </div>


                <div class="upravImg">
                    <div class="form-group boxed">
                        <div class="container text-center">
                            <img style="max-height: 250px; " class="img-fluid"
                                 src={  'https://225304.selcdn.ru/axisdb/'+ upravImg }/>
                        </div>
                    </div>
                </div>

                {#if (dop_uprav !== 'Нет')}
                    <div class="upravDopImg">
                        <div class="form-group boxed">
                            <div class="container text-center">
                                <img style="max-height: 250px; " class="img-fluid"
                                     src={  'https://225304.selcdn.ru/axisdb/'+ upravDopImg }/>
                            </div>
                        </div>
                    </div>
                {/if}
            {/if}


        </div>
    </div>
{/await}

<!--<div id="toast-ind1" class="toast-box toast-top bg-danger">-->
<!--    <div class="in">-->
<!--        <div class="text">-->
<!--            При высоте больше 1400 мм рекомендуется поставить перемычку-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
